<template>
  <div class="productAnt">

    <div class="visual_switch">
      <div class="switch" 
            v-bind:class="{ active: curProduct == 0 }"
            v-on:click="scrollToProduct(0)"></div>
      <div class="switch" 
            v-bind:class="{ active: curProduct == 1 }"
            v-on:click="scrollToProduct(1)"></div>
      <div class="switch" 
            v-bind:class="{ active: curProduct == 2 }"
            v-on:click="scrollToProduct(2)"></div>
    </div> 

    <div class="fullpage-container hidden-sm-down">
      <div class="fullpage-container__bgImg"></div>
      <div class="fullpage-wp" v-fullpage="opts" ref="fullpage">
        
        <div class="page-1 page">
          <div class="fullpage-container__title">
            威滅 速效殺蟻藥餌
          </div>
          <div class="fullpage-container__bottomPanel">
            <p class="fullpage-container__bottomPanel__text1">
              速效配方專為螞蟻而設，連環殺滅功能，助你輕鬆解決螞蟻困擾。
            </p>

            <div class="fullpage-container__bottomPanel__sellingLocation" @click="toggleOverlay(0)">
              <img :src="locationIcon" :srcset="locationIcon2x+' 2x'"/>
              <div class="name">銷售地點</div>
            </div>

            <img class="fullpage-container__bottomPanel__productImage" src="../assets/productAnt-section2.png"/>
            <div class="btnContainer">
              <ul>
                <li v-on:click="toggleOverlay(index)" v-for="(item, index) in overlayMenu" v-if="index != 0">
                  <img :src="item.img" :srcset="item.srcset+' 2x'"/>
                  <div class="name">{{item.name}}</div>
                </li>
              </ul>
            </div>

            <div class="fullpage-container__bottomPanel__claimRef">
              <div>
                <!-- *資料來源：Home Care: Euromonitor from trade sources/national statistics. -->
                *資料來源：Euromonitor Retail Value Comparison of Insecticide Baits Category in Hong Kong, Data 2014-2017, 2019-2021
              </div>
              <!-- <div>
                URL: http://www.portal.euromonitor.com/portal/statistics/tab. Accessed on 24 March 2016
              </div> -->
            </div>

            <div class="pageControl">
              <button data-button="next" class="" @click="moveNextPage">
                <span class="item item-half item-icon white">
                  <svg class="icon icon-arrow icon-rotate-down" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 60 60" xml:space="preserve" preserveAspectRatio="xMidYMid meet">
                    <path class="icon-path" d="M14.2,52.5c-1.8,1.8-1.8,4.7,0,6.5c1.8,1.8,4.6,1.8,6.4,0l25.3-25.8c1.8-1.8,1.8-4.7,0-6.5L20.6,1c-1.8-1.8-4.6-1.8-6.4,0c-1.8,1.8-1.8,4.7,0,6.5L34.9,30L14.2,52.5z"></path>
                  </svg>
                </span>
              </button>
            </div>
          </div>
        </div>

        <div class="page-2 page">
          <div class="suggestion-container">
            <div class="suggestion">
              <h2>威滅其他產品</h2>
              <div class="product-btn">
                <div class="product-img">
                  <img src="../assets/cockroach-suggest.png"/>
                </div>
                <router-link to="/product/cockroach" class="label-yellow">
                  <div class="aim">
                    <img src="../assets/aimIcon.png"/>
                  </div>
                  <span>速效曱甴藥餌</span>
                </router-link>
              </div>
            </div>
          </div>
          <div class="pageControl">
            <button data-button="next" class="" @click="moveNextPage">
              <span class="item item-half item-icon white">
                <svg class="icon icon-arrow icon-rotate-down" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 60 60" xml:space="preserve" preserveAspectRatio="xMidYMid meet">
                  <path class="icon-path" d="M14.2,52.5c-1.8,1.8-1.8,4.7,0,6.5c1.8,1.8,4.6,1.8,6.4,0l25.3-25.8c1.8-1.8,1.8-4.7,0-6.5L20.6,1c-1.8-1.8-4.6-1.8-6.4,0c-1.8,1.8-1.8,4.7,0,6.5L34.9,30L14.2,52.5z"></path>
                </svg>
              </span>
            </button>
          </div>
        </div>

        <div class="page-3 page">
         <contact></contact>
          <div class="pageControl">
            <button data-button="next" class="" @click="scrollToProduct(0)">
              <span class="item item-half item-icon white">
                <svg class="icon icon-arrow icon-rotate-up" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 60 60" xml:space="preserve" preserveAspectRatio="xMidYMid meet">
                  <path class="icon-path" d="M14.2,52.5c-1.8,1.8-1.8,4.7,0,6.5c1.8,1.8,4.6,1.8,6.4,0l25.3-25.8c1.8-1.8,1.8-4.7,0-6.5L20.6,1c-1.8-1.8-4.6-1.8-6.4,0c-1.8,1.8-1.8,4.7,0,6.5L34.9,30L14.2,52.5z"></path>
                </svg>
              </span>
            </button>
          </div>
          <henkel-footer></henkel-footer>
        </div>
      </div>
    </div>
  
    <!-- Mobile -->
    <div class="hidden-md-up">
      <div class="section1">
        <img src="../assets/productAnt-section1-m.jpg"/>
      </div>

      <div class="section2">
        <div class="productImg">
          <img src="../assets/productAnt-section2.png"/>
        </div>

        <div class="text">
          <p class="title">
            威滅 速效殺蟻藥餌
          </p>

          <p class="text1">
            速效配方專為螞蟻而設，連環殺滅功能，助你輕鬆解決螞蟻困擾。
          </p>  
        </div>

        <div class="sellingLocation" @click="toggleOverlay(0)">
          <img :src="locationIcon" />
          <div class="name">銷售地點</div>
        </div>

        <div class="btnContainer">
          <ul>
            <li v-on:click="toggleOverlay(index)" v-for="(item, index) in overlayMenu" v-if="index != 0">
              <img :src="item.img" :srcset="item.srcset+' 2x'"/>
              <div class="name">{{item.name}}</div>
            </li>
          </ul>
        </div>

        <div class="claimRef">
          <!-- *資料來源:Home Care: Euromonitor from trade sources/national statistics. -->
          *資料來源：Euromonitor Retail Value Comparison of Insecticide Baits Category in Hong Kong, Data 2014-2017, 2019-2021
        </div>
        <!-- <div class="claimRef">
          URL:http://www.portal.euromonitor.com/portal/statistics/tab. Accessed on 24 March 2016
        </div> -->
      </div>

      <div class="section-suggest">
        <div class="suggestion-container">
          <div class="suggestion">
            <h2>威滅其他產品</h2>
            <div class="product-btn">
              <div class="product-img">
                <img src="../assets/cockroach-suggest.png"/>
              </div>
              <router-link to="/product/cockroach" class="label-yellow">
                <div class="aim">
                  <img src="../assets/aimIcon.png"/>
                </div>
                <span>速效曱甴藥餌</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <contact></contact>
      <henkel-footer></henkel-footer>
    </div>

    <div class="overlay" :class="{active: openOverlay}">
      <div class="overlayBg" v-on:click="toggleOverlay()"></div>
      <div class="outer">
      
        <div class="container">
          <div class="closeBtn">
            <img v-on:click="toggleOverlay()" src="../assets/cross.png" :srcset="crossBtn+' 2x'"/>
          </div>

          <div class="tab tabChannel" :class="{active: tabIndex === 0}">
            <div class="tabName">
              <img src="../assets/productAnt-section2-icon1.png"/>
              銷售地點
            </div>
            <div class="tabTitle">
              威滅產品於下列商戶有售
            </div>

            <div class="shoplistCol row">
              
              <div class="col-md-4 offset-md-2">

                <div class="shoplist welcomeShopLink">
                  <img class="shopLogo" src="../assets/welcome.jpg"/>
                  <div class="shopInfo">
                    <div class="shopName">惠康超級市場</div>
                    <a href="https://www.wellcome.com.hk/wd2shop/zh/html/search/search-result.html?hs_srch_word=combat" target="_blank">
                      <img class="shoplinkBtn" src="../assets/onlineShopBtn.png"/>
                    </a>
                  </div>
                </div>

                <div class="shoplist">
                    <img class="shopLogo" src="../assets/parkinShop.png"/>
                  <div class="shopInfo">
                    <div class="shopName">百佳超級市場</div>
                    <a href="http://www.parknshop.com/search?code=ALL&text=%E5%A8%81%E6%BB%85&searchField=%E5%A8%81%E6%BB%85" target="_blank">
                      <img class="shoplinkBtn" src="../assets/onlineShopBtn.png"/>
                    </a>
                  </div>
                </div>

              </div>

              <div class="col-md-6">
                <div class="shoplist row">
                  <div class="col-sm-4">
                    <img class="shopLogo" src="../assets/aeon.jpg"/>
                  </div>
                  <div class="shopInfo col-sm-8">
                    <div class="shopName">AEON</div>
                    <!--
                    <a href="https://www.aeoncity.com.hk/zh/Search.html?keyword=%E5%A8%81%E6%BB%85" target="_blank">
                      <img class="shoplinkBtn" src="../assets/onlineShopBtn.png"/>
                    </a>
                    -->
                  </div>
                </div>

                <div class="shoplist row">
                  <div class="col-sm-4">
                    <img class="shopLogo" src="../assets/yata.jpg"/>
                  </div>
                  <div class="shopInfo col-sm-8">
                    <div class="shopName">一田 YATA</div>
                  </div>
                </div>

                <div class="shoplist row">
                  <div class="col-sm-4">
                    <img class="shopLogo" src="../assets/apita.jpg"/>
                  </div>
                  <div class="shopInfo col-sm-8">
                    <div class="shopName">UNY / APITA</div>
                  </div>
                </div>

                <div class="shoplist row">
                  <div class="col-sm-4">
                    <img class="shopLogo" src="../assets/bamboos.png" style="width:60%"/>
                  </div>
                  <div class="shopInfo col-sm-8">
                    <div class="shopName">百本旺角市集</div>
                  </div>
                </div>

                <div class="shoplist row">
                  <div class="col-sm-4">
                    <img class="shopLogo" src="../assets/hktvMall.jpg"/>
                  </div>
                  <div class="shopInfo col-sm-8">
                    <div class="shopName">HKTV Mall</div>
                    <a href="https://www.hktvmall.com/hktv/zh/main/search?page=0&q=%3Arelevance%3Acategory%3AAA11824000001%3Azone%3Asupermarket%3Abrand%3ACombat%3Astreet%3Amain%3A" target="_blank">
                      <img class="shoplinkBtn" src="../assets/onlineShopBtn.png"/>
                    </a>
                  </div>
                </div>

                <div class="shoplist row">
                  <div class="col-sm-4">
                    <img class="shopLogo" src="../assets/ztore.jpg"/>
                  </div>
                  <div class="shopInfo col-sm-8">
                    <div class="shopName">Ztore 士多</div>
                    <a href="https://www.ztore.com/tc/search/combat" target="_blank">
                      <img class="shoplinkBtn" src="../assets/onlineShopBtn.png"/>
                    </a>
                  </div>
                </div>

                <div class="shoplist row">
                  <div class="col-sm-4">
                    <img class="shopLogo" src="../assets/pandamart.jpg"/>
                  </div>
                  <div class="shopInfo col-sm-8">
                    <div class="shopName">PandaMart</div>
                    <a href="https://www.foodpanda.hk/groceries#all-pandamarts" target="_blank">
                      <img class="shoplinkBtn" src="../assets/onlineShopBtn.png"/>
                    </a>
                  </div>
                </div>

                <div class="shoplist row">
                  <div class="col-sm-4">
                    <img class="shopLogo" src="../assets/homeplus.jpg"/>
                  </div>
                  <div class="shopInfo col-sm-8">
                    <div class="shopName">HOMEPLUS</div>
                    <a href="https://www.home-plus.hk/tc_hk/products?brand=17504" target="_blank">
                      <img class="shoplinkBtn" src="../assets/onlineShopBtn.png"/>
                    </a>
                  </div>
                </div>

                <div class="shoplist row">
                  <div class="col-sm-4">
                    <img class="shopLogo" src="../assets/healthstore.jpg"/>
                  </div>
                  <div class="shopInfo col-sm-8">
                    <div class="shopName">HealthStore</div>
                    <a href="https://www.healthstore.com.hk/collections/combat-威滅?utm_source=combat&utm_medium=referral&utm_campaign=brandsite" target="_blank">
                      <img class="shoplinkBtn" src="../assets/onlineShopBtn.png"/>
                    </a>
                  </div>
                </div>

                <div class="shoplist row">
                  <div class="col-sm-4">
                    <img class="shopLogo" src="../assets/all_pharmacy.jpg"/>
                  </div>
                  <div class="shopInfo col-sm-8">
                    <div class="shopName">各大藥行藥房</div>
                    <a href="https://docs.google.com/spreadsheets/d/1038226dN2l4fc_kwaJjAP6E5yiUBQNLo/edit?usp=sharing&ouid=109814576360705695639&rtpof=true&sd=true" target="_blank">
                      <img class="shoplinkBtn" src="../assets/btn-pharmacylist.png"/>
                    </a>
                  </div>
                </div>
                
              </div>
            </div>
          </div>

          <div class="tab tabInfo" :class="{active: tabIndex === 1}">
            <div class="tabName">
              <img src="../assets/productAnt-section2-icon2.png"/>
              產品詳細資料
            </div>
            <div class="shoplistCol row">
              <div class="col-md-6">
                <div class="shoplist text-sm-center">
                  <img class="shopLogo logo2" src="../assets/productAnt-section2-overlay.png"/>
                </div>
              </div>
              <div class="col-md-6">
                <div class="shoplist">
                  <div class="shopInfo">
                    藥餌數目:  6件裝 <br/>
                    有效成份: Fipronil (快倍隆)<br/>
                    生產地: 韓國 <br/><br/>

                    優點: <br/>
                    <ul class="bulletList">
                      <li>連環殺滅功能，將巢穴裡面螞蟻一網打盡。</li>
                      <li>餌盒設計方便，簡單易用。</li>
                      <li>無味無臭，對人體及環境不構成傷害。</li>
                      <li>效力持續三個月有效。</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="tab tabMethod" :class="{active: tabIndex === 2}">
            <div class="tabName">
              <img src="../assets/productAnt-section2-icon3.png"/>
              使用方法
            </div>

            <div class="shoplistCol row">
              <div class="col-md-3" v-for="step in overlayMethod">
                <div class="shoplist">
                  <div class="imageContainer">
                    <img class="shopLogo" :src="step.src" :srcset="step.srcset+' 2x'"/>
                  </div>
                  <div class="methodNum">{{step.index}}</div>
                  <div class="shopName">{{step.text}}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="tab tabWorks" :class="{active: tabIndex === 3}">
            <div class="tabName">
              <img src="../assets/productAnt-section2-icon4.png"/>
              連環殺滅功能
            </div>

            <div class="shoplistCol row">
              <div class="col-md-12 hidden-sm-down">
                <div class="shoplist">
                  <img class="shopLogo" src="../assets/overlay-work.png"/>
                </div>
              </div>
              <div class="col-md-4" v-for="(work, index) in overlayWorks">
                <div class="shoplist">
                  <div class="imageContainer hidden-md-up">
                    <img class="shopLogo" :src="work.src" :srcset="work.srcset+' 2x'"/>
                  </div>
                  <div class="methodNum">{{index + 1}}</div>
                  <div class="shopName">{{work.text}}</div>
                </div>
              </div>
              <div class="col-md-12 text-center">
                <div class="shoplist">
                  <div class="shopName">想了解更多詳細威滅藥餌的殺滅的效用，請瀏覽<router-link :to="'/preventiontips/insecticideguide'" class="underline">藥餌的殺滅效用</router-link></div>
                </div>
              </div>
            </div>
          </div>
          
          <div class="arrowContainer">
            <div class="leftArrow" v-on:click="previousOverlay()">
              <img src="../assets/arrow.png" :srcset="arrowBtn+' 2x'"/>
            </div>
            <div class="rightArrow" v-on:click="nextOverlayTab()">
              <img src="../assets/arrow.png" :srcset="arrowBtn+' 2x'"/>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  created () {
    window.document.title = '威滅Combat 速效藥餌'
    window.scrollTo(0, 0)

    window.onresize = () => {
      var vw = document.documentElement.clientWidth
      if (vw >= 780 && !this.openOverlay) {
        location.reload()
      }
    }
  },
  data () {
    return {
      openOverlay: false,
      tabIndex: 1,
      curProduct: 0,
      locationIcon: require('../assets/locationIcon.png'),
      locationIcon2x: require('../assets/locationIcon@2x.png'),
      crossBtn: require('../assets/cross@2x.png'),
      arrowBtn: require('../assets/arrow@2x.png'),
      opts: {
        start: 0,
        overflow: '',
        dir: 'v',
        duration: 500,
        beforeChange: (obj, prev, next) => {
          this.curProduct = next
        },
        afterChange: (obj, prev, next) => {
          // console.log('after', prev)
        }
      },
      overlayWorks: [
        {
          src: require('../assets/overlay-work1.png'),
          srcset: require('../assets/overlay-work1@2x.png'),
          text: '螞蟻被誘進餌盒進食藥餌'
        },
        {
          src: require('../assets/overlay-work2.png'),
          srcset: require('../assets/overlay-work2@2x.png'),
          text: '螞蟻吃過藥餌後爬出，將藥餌帶回巢穴'
        },
        {
          src: require('../assets/overlay-work3.png'),
          srcset: require('../assets/overlay-work3@2x.png'),
          text: '回巢後死亡，迅速將藥餌傳播給同類，將巢穴內的螞蟻一網打盡'
        }
      ],
      overlayMenu: [
        {

          img: require('../assets/productAnt-section2-icon1.png'),
          srcset: require('../assets/productAnt-section2-icon1.png'),
          name: '銷售地點'
        },
        {
          img: require('../assets/productAnt-section2-icon2.png'),
          srcset: require('../assets/productAnt-section2-icon2@2x.png'),
          name: '產品詳細資料'
        },
        {
          img: require('../assets/productAnt-section2-icon3.png'),
          srcset: require('../assets/productAnt-section2-icon3@2x.png'),
          name: '使用方法'
        },
        {
          img: require('../assets/productAnt-section2-icon4.png'),
          srcset: require('../assets/productAnt-section2-icon4@2x.png'),
          name: '連環殺滅功能'
        }
      ],
      overlayMethod: [
        {
          src: require('../assets/overlay-method1.png'),
          srcset: require('../assets/overlay-method1@2x.png'),
          index: 1,
          text: '將餌盒背後的黏貼紙撕開'
        },
        {
          src: require('../assets/overlay-method2.png'),
          srcset: require('../assets/overlay-method2@2x.png'),
          index: 2,
          text: '把整個餌盒貼於螞蟻經常出沒的地方，如廚房牆邊、窗邊、垃圾桶周圍及露台盆栽、花槽側。'
        },
        {
          src: require('../assets/overlay-method3.png'),
          srcset: require('../assets/overlay-method3@2x.png'),
          index: 3,
          text: '妥善放置餌盒，儘量使其穩固於牆壁、地面、角落。'
        },
        {
          src: require('../assets/overlay-method4.png'),
          srcset: require('../assets/overlay-method4@2x.png'),
          index: 4,
          text: '欲獲得最佳效果，應同時使用整盒 6 個餌盒。'
        },
        {
          src: require('../assets/overlay-method5.png'),
          srcset: require('../assets/overlay-method5@2x.png'),
          index: 5,
          text: '請勿把噴霧殺蟲劑直接噴在餌盒上或其附近。'
        },
        {
          src: require('../assets/overlay-method6.png'),
          srcset: require('../assets/overlay-method6@2x.png'),
          index: 6,
          text: '定時每隔三個月更換一次餌盒，以達致長期最佳後果。'
        },
        {
          src: require('../assets/overlay-method7.png'),
          srcset: require('../assets/overlay-method7@2x.png'),
          index: 7,
          text: '請勿騷擾正在取食藥餌的螞蟻，以免減低效能。'
        },
        {
          src: require('../assets/overlay-method8.png'),
          srcset: require('../assets/overlay-method8@2x.png'),
          index: 8,
          text: '藥餌初用時會吸引螞蟻聚集，故附近螞蟻數量會暫時增加，一週內會明顯減少。'
        }
      ]
    }
  },
  methods: {
    toggleOverlay (index) {
      if (index === undefined) {
        this.openOverlay = false
        return
      }

      this.openOverlay = !this.openOverlay
      this.tabIndex = index
    },
    scrollToProduct (index) {
      this.curProduct = index
      this.$refs.fullpage.$fullpage.moveTo(index)
    },
    moveNextPage () {
      this.$refs.fullpage.$fullpage.moveNext()
    },
    nextOverlayTab () {
      if (this.tabIndex === this.overlayMenu.length - 1) {
        this.tabIndex = 0
        return
      }
      this.tabIndex += 1
    },
    previousOverlay () {
      if (this.tabIndex === 0) {
        this.tabIndex = this.overlayMenu.length - 1
        return
      }

      this.tabIndex -= 1
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass">
@import "../styles/_vars.sass"
@import "../styles/_overlayArrow.sass"
@import "../styles/_fullpage.sass"
@import "../styles/_pageControl.sass"
@import "../styles/_visualSwitch.sass"
@import "../styles/_sellingLocation.sass"

.productAnt
  padding-top: $topMenu-height

  .bulletList
    list-style: disc
    li
      list-style-position: inside
      text-indent: -20px
      padding-left: 28px

  .visual_switch
    @include visualSwitch
    @media only screen and (max-width: 768px)
      display: none

  .fullpage-container
    @include fullpage-container
    background-color: black
    
    &__bgImg
      background-image: url('../assets/productAnt-section1.jpg')
      background-size: 40%
	
    .pageControl
      @include pageControl

    .page-1
      .fullpage-container__bottomPanel__productImage
        bottom: 50%
        right: 22%
        width: 35vw

    .page-3
      .pageControl
        bottom: 195px

      .footer
        position: absolute
        bottom: 0
        width: 100%

  .btnContainer
    position: relative
    font-size: 16px
    padding-right: 40px

    @media only screen and (min-width: 768px)
      position: absolute
      bottom: 28%
      right: -15px

    @media only screen and (min-width: 1000px)
      position: absolute
      bottom: 28%
      right: 3vw

    ul
      li
        display: block
        position: relative
        cursor: pointer
        font-weight: bold
        overflow: hidden
        margin-top: 15px

        @media only screen and (max-width: 768px)
          display: block
          overflow: hidden
          margin-bottom: 20px
          max-width: 200px
          width: 100%

        img
          float: left
          width: 47px
        
        .name
          margin-left: 10px
          margin-right: 10px
          padding-top: 14px
          float: left

  .title
    font-size: 48px
    line-height: 35px

  .section1
    background-color: #08080b
    width: 100%
    overflow: auto
    position: relative

    @media only screen and (max-width: 768px)
      position: initial

    img
      width: 100%

    p
      color: white
      position: absolute
      left: 64px

      &.title
        bottom: 31px

  .section2
    background-color: $theme-yellow
    padding-top: 64px
    padding-bottom: 64px
    padding-right: 73px
    padding-left: 73px
    overflow: auto
    font-size: 16px
    z-index: 99999

    .sellingLocation
      @include sellingLocation
      position: relative
      left: 0
      margin-top: 30px

      @media only screen and (max-width: 414px)
        width: 100%

    .claimRef
      word-wrap: break-word
      /* margin-bottom: 10px */
      font-size: 10px

    .upper
      overflow: auto

    @media only screen and (max-width: 768px)
      padding: 28px
      margin-top: -20%

      .productImg
        width: 100%
        text-align: center
        float: none

        img
          width: 79%
    
    @media only screen and (max-width: 479px)
      padding: 18px

    .text
      color: black

      @media only screen and (max-width: 768px)
        width: 100%
        float: none

      .title
        margin-top: 6%
        font-size: 30px
        padding-right: 30px
        line-height: 37px
        font-weight: bold

      .text1
        line-height: 25px
        font-size: 1.2em

  .noProductImg
    @media only screen and (max-width: 768px)
      margin-top: 0

  .section-suggest
    background-color: $theme-gray
    padding: 40px
    overflow: auto
    font-size: 16px

    .suggestion-container

      .suggestion

        h2
          font-size: 2.2em
          margin-bottom: 18px

        .product-btn
          width: 100%;

  .overlay
    position: fixed
    top: 0px
    left: 0px
    right: 0px
    bottom: 0px
    z-index: 9
    opacity: 8
    color: white
    width: 100%
    height: 100%
    pointer-events: none
    opacity: 0
    overflow: auto
    display: table
    z-index: 999

    &.active
      opacity: 1
      pointer-events: auto

    .overlayBg
      background-color: rgba(0,0,0,.85)
      position: absolute
      top: 0
      left: 0
      width: 100vw
      height: 100vh
      cursor: pointer
    
    .outer
      display: table-cell
      vertical-align: middle

      // @media only screen and (max-width: 768px)
      @media only screen and (max-width: 575.98px)
        display: inline-block

    .container
      background-color: #404040
      padding: 38px
      position: relative
      max-height: 100%
      left: 0
      right: 0

      @media only screen and (max-width: 768px)
        top: 0

      // @media only screen and (max-width: 320px)
      //   padding: 20px
      //   height: 100vh


      .arrowContainer
        @extend .arrowContainer
        // margin-top: 10px

      .closeBtn
        float: right
        right: 0
        top: 0
        cursor: pointer

      .tab
        display: none

        .shoplistCol
          overflow: auto
          max-height: 60vh
          -webkit-overflow-scrolling: touch

          &::-webkit-scrollbar
            width: 5px
            background: transparent

          &::-webkit-scrollbar-thumb
            background: white
            border-radius: 20px

          @media only screen and (max-width: 768px)
            max-height: 60vh
            overflow: auto

          @media only screen and (max-width: 320px)
            max-height: 60vh

        &.tabChannel
          .shoplistCol
            // padding-top: 20px
            // overflow: auto
            // max-height: 60vh
            height: 45vh

            @media only screen and (max-width: 320px)
              // max-height: 58vh
              height: 50vh

            & > div:first-child
              @media only screen and (min-width: 768px)
                border-right: 2px solid #565656

          .shoplist
            padding-left: 10%
            padding-right: 10%
            
            @media only screen and (max-width: 768px)
              padding: 25px !important
              border-bottom: 2px solid #565656

        &.tabInfo
          .tabName
            margin-bottom: 30px
            
            @media only screen and (max-width: 320px)
              margin-bottom: 10px

          .shoplist
            @media only screen and (max-width: 768px)
              padding-left: 0 !important
              padding-right: 0 !important
              padding-bottom: 5% !important
            
            img
              max-width: 25vw
              @media only screen and (max-width: 768px)
                max-width: none

              &.logo2
                width: 100%
                max-width: 90% 
         
        &.tabMethod
          .shoplistCol
            overflow: auto
            max-height: 60vh

            .shoplist
              padding-bottom: 10px

              .imageContainer
                text-align: center
                .shopLogo
                  width: 120px
                  height: 120px

                  @media only screen and (max-width: 768px)
                    width: 70%
                    height: 70%

              .methodNum
                font-size: 40px
                font-weight: bold
                margin-top: -20px

              .shopName
                margin-top: 20px


        &.active
          display: block

        .tabName
          font-size: 24px
          @media only screen and (max-width: 768px)
            font-size: 18px

          img
            width: 47px
        
        .tabTitle
          width: 100%
          text-align: center
          font-size: 20px
          margin-top: 20px
          margin-bottom: 30px
          
          @media only screen and (max-width: 768px)
            margin-top: 10%

          @media only screen and (max-width: 320px)
            margin-top: 10%
            margin-bottom: 10%

        .shoplistCol

          & > div:last-child
            .shoplist
              padding-bottom: 20px

          .shoplist
            font-size: 14px
            padding-bottom: 20px
            padding-left: 0
            padding-right: 0

            @media only screen and (max-width: 768px)
              padding-bottom: 25px
              padding-top: 25px

            .shopLogo
              width: 100%
              margin-bottom: 10px

            .shopInfo
              overflow: hidden

              .shopName
                float: left
                padding-top: 5px

              .shoplinkBtn
                float: left
                width: 85px
                margin-top: 3px
                margin-left: 10px
                cursor: pointer
              
              a
                display: inline-block
                cursor: pointer

        &.tabWorks
          .shoplistCol
            .shoplist
              padding: 0
              padding-top: 3%
              font-size: 14px
              
              .imageContainer
                text-align: center
                .shopLogo
                  width: 90%

              .methodNum
                font-size: 40px
                font-weight: bold
                margin-top: 20px

              .shopName
                margin-top: 20px
                a
                  color: white

.suggestion-container
  background-color: $theme-gray
  width: 100%
  height: 100%
  display: flex
  align-items: center

  .suggestion
    width: 100%
    text-align: center
    color: white

    h2
      font-size: 48px
      font-weight: bold
      margin-bottom: 36px

    .product-btn
      width: 284px
      display: inline-block
      padding: 0 10px

      .product-img
        width: 100%
        display: inline-block
        margin: 0 auto
        position: relative
        max-width: 300px

        img
          position: relative
          width: 100%

.label-yellow
  background-color: #fac112
  color: black
  padding: 7px 18px
  width: 100%
  border-radius: 15px
  text-align: center
  position: relative
  overflow: auto
  font-size: 18px
  display: inline-block
  font-size: 0

  .aim
    width: 20px
    height: 20px
    display: inline-block
    vertical-align: middle

    img
      width: 100%
      float: left
  
  span
    display: inline-block
    vertical-align: middle
    line-height: 1
    font-size: 18px


</style>



// WEBPACK FOOTER //
// ProductAnt.vue?a14bf4ee